import PhoneArea from "components/PhonePreview/PhoneArea"
import { FORM_NAMES } from "constants/index"
import React from "react"
import { connect } from "react-redux"
import { formValueSelector } from "redux-form"
import Circles from "./LayoutPreviews/circles"
import Classic from "./LayoutPreviews/classic"
import ClassicTopButton from "./LayoutPreviews/classicTopButton"
import Dialpad from "./LayoutPreviews/dialpad"
import SimpleStack from "./LayoutPreviews/simpleStack"

const PhonePreview = ({
  landingSetup,
  bgImage,
  layout,
  button,
  menu,
  header,
}) => {
  const renderPreview = () => {
    switch (layout) {
      case "1":
        return (
          <Classic
            bgUrl={bgImage?.editedImage}
            headerText={header?.title}
            headerFont={header?.font}
            headerFontColor={header?.font_color}
            logoUrl={header?.logoImage?.editedImage}
            headerType={header?.header_type}
            headerColor={header?.header_color}
            menuItems={landingSetup?.menu}
            buttonText={button?.button_text}
            buttonColor={button?.button_color}
            buttonTextColor={button?.text_color}
            menuTabColor={menu?.menu_tab_color}
            menuTextColor={menu?.menu_text_color}
            menuFont={menu?.menu_font}
          />
        )
      case "4":
        return (
          <ClassicTopButton
            bgUrl={bgImage?.editedImage}
            headerText={header?.title}
            headerFont={header?.font}
            headerFontColor={header?.font_color}
            logoUrl={header?.logoImage?.editedImage}
            headerType={header?.header_type}
            headerColor={header?.header_color}
            menuItems={landingSetup?.menu}
            buttonText={button?.button_text}
            buttonColor={button?.button_color}
            buttonTextColor={button?.text_color}
            menuTabColor={menu?.menu_tab_color}
            menuTextColor={menu?.menu_text_color}
            menuFont={menu?.menu_font}
          />
        )
      case "2":
        return (
          <Dialpad
            bgUrl={bgImage?.editedImage}
            headerText={header?.title}
            headerFont={header?.font}
            headerFontColor={header?.font_color}
            logoUrl={header?.logoImage?.editedImage}
            headerType={header?.header_type}
            headerColor={header?.header_color}
            menuItems={landingSetup?.menu}
            buttonText={button?.button_text}
            buttonColor={button?.button_color}
            buttonTextColor={button?.text_color}
            menuTabColor={menu?.menu_tab_color}
            menuTextColor={menu?.menu_text_color}
            menuFont={menu?.menu_font}
          />
        )
      case "5":
        return (
          <SimpleStack
            bgUrl={bgImage?.editedImage}
            headerText={header?.title}
            headerFont={header?.font}
            headerFontColor={header?.font_color}
            logoUrl={header?.logoImage?.editedImage}
            headerType={header?.header_type}
            headerColor={header?.header_color}
            menuItems={landingSetup?.menu}
            buttonText={button?.button_text}
            buttonColor={button?.button_color}
            buttonTextColor={button?.text_color}
            menuTabColor={menu?.menu_tab_color}
            menuTextColor={menu?.menu_text_color}
            menuFont={menu?.menu_font}
          />
        )
      case "7":
        return (
          <Circles
            bgUrl={bgImage?.editedImage}
            headerText={header?.title}
            headerFont={header?.font}
            headerFontColor={header?.font_color}
            logoUrl={header?.logoImage?.editedImage}
            headerType={header?.header_type}
            headerColor={header?.header_color}
            menuItems={landingSetup?.menu}
            buttonText={button?.button_text}
            buttonColor={button?.button_color}
            buttonTextColor={button?.text_color}
            menuTabColor={menu?.menu_tab_color}
            menuTextColor={menu?.menu_text_color}
            menuFont={menu?.menu_font}
          />
        )
      default:
        return (
          <SimpleStack
            bgUrl={bgImage?.editedImage}
            headerText={header?.title}
            headerFont={header?.font}
            headerFontColor={header?.font_color}
            logoUrl={header?.logoImage?.editedImage}
            headerType={header?.header_type}
            headerColor={header?.header_color}
            menuItems={landingSetup?.menu}
            buttonText={button?.button_text}
            buttonColor={button?.button_color}
            buttonTextColor={button?.text_color}
            menuTabColor={menu?.menu_tab_color}
            menuTextColor={menu?.menu_text_color}
            menuFont={menu?.menu_font}
          />
        )
    }
  }

  return (
    <PhoneArea style={{ paddingLeft: "0px", paddingBottom: "0px" }}>
      {renderPreview()}
    </PhoneArea>
  )
}

const selector = formValueSelector(FORM_NAMES.LANDING_SCREEN)

const mapStateToProps = state => ({
  layout: selector(state, "layout.layout"),
  bgImage: selector(state, "background.bgImage"),
  button: selector(state, "button"),
  landingSetup: state.LandingScreen.landingSetup,
  menu: selector(state, "menu.style"),
  header: selector(state, "header"),
})

export default connect(mapStateToProps)(PhonePreview)
